// components/RejectButton.tsx

import React, { useState } from 'react';

import ConfirmationModal from './ConfirmationModal';
import apiService from '../../../src/services/apiService';

interface RejectButtonProps {
  title: string;
  id: number | string;
  apiPath: string;
  onSuccess?: () => void;
}

const RejectButton: React.FC<RejectButtonProps> = ({ title, id, apiPath, onSuccess }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleReject = async (remarks: string) => {
    try {
      setLoading(true);

      const response = await apiService.post(`${apiPath}/${id}/reject`, {
        remarks,
      });

      if (response?.data) {
        setShowModal(false);
        onSuccess?.();
      }
    } catch (error) {
      console.error('Reject failed', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button onClick={() => setShowModal(true)} className="px-4 py-2 rounded-md font-medium text-white bg-red-600 hover:bg-red-700">
        Reject
      </button>

      {showModal && (
        <ConfirmationModal
          title={`Reject ${title}`}
          message={`Are you sure you want to reject this ${title}?`}
          onConfirm={handleReject}
          onCancel={() => setShowModal(false)}
          loading={loading}
        />
      )}
    </>
  );
};

export default RejectButton;
